// import axios, {AxiosResponse} from 'axios';
import {useState, useEffect} from 'react';
import fetch from 'node-fetch';
import {isDefined} from '../../types/type-guards';
// import {singletonFactory} from './common-utils';

/**
 * Objective of this module is to provide following features:
 * - [x] Simple wrapper for making network requests
 * - [ ] Latency Tracking
 * - [ ] Auto push GA analytics related to API endpoints
 * - [ ] Cancel if existing request over the air
 * - [ ] Retry as per specified count
 * - [ ] Short-Circuit request as per defined time
 * - [ ] Priority fetching
 * - [ ] No network response
 * - [ ] Logging utility logger/index.ts or logger.server.ts
 */

// const xhrHelperInstance = axios.create();
// const cancelToken = axios.CancelToken;

export type xhrType = 'GET' | 'POST';

// interface xhrGetCallCacheType<T> {
//   [key: string]: Promise<AxiosResponse<T>>;
// }

// interface ICacheConfig<ResponseDataGeneric> {
//   validator: (data: ResponseDataGeneric) => boolean;
//   expiry: Date;
// }

// type xhrGetCallCacheType = Record<string, Promise<AxiosResponse<any>>>;

// const xhrGetCallCache: xhrGetCallCacheType = {};

interface IXhrHelper<RequestDataGeneric> {
  name: string;
  type: xhrType;
  url: string;
  requestData?: RequestDataGeneric;
}

export async function fetchHelper<RequestDataGeneric, ResponseDataGeneric>({
  name,
  type,
  url,
  requestData,
}: IXhrHelper<RequestDataGeneric>): Promise<ResponseDataGeneric> {
  let params = {};

  const options = {
    headers: {},
  //  credentials: 'include',
    method: type,
  };

  if (type === 'POST') {
    options.body = JSON.stringify(params);
  }

  const rawResponse = await fetch(url, options);
  const respJson = await rawResponse.json();
  return respJson;
}
